module.exports = __webpack_public_path__ + "img/server.51e402f2.svg";